import type { ImageBackgroundPosition } from "./types";

export const DEFAULT_GAP = 16;
export const DEFAULT_PADDING = 16;
export const DEFAULT_POSITION: ImageBackgroundPosition = "top";
